import { mapGetters } from 'vuex'
import Status from '@/status'

export default {
  name: 'create',
  components: {},
  props: [],
  data () {
    return {
      group_alias: {
        grp_id: ''
      },
      errors: {},
      btn_submit: false
    }
  },
  computed: {
    ...mapGetters({
      groups: 'Group/getListGroup'
    })
  },
  mounted () {
  
    Promise.all([
      this.$store.dispatch('Group/getListGroup', {page: 1, per_page: 'all', status: Status.APPROVAL})
    ]).then(res => {
      
    }).catch(errors => {
      
    })
  },
  methods: {
    showCreateModal () {
      this.errors = {}
      this.group_alias = {}
      this.group_alias.grp_id = ''
      this.$refs.create.show()
    },
    create () {
      this.btn_submit = true
    
      this.$store.dispatch('GroupAlias/createGroupAlias', {
        group_alias: this.group_alias
      }).then(res => {
        this.$notify({
          group: 'success',
          title: this.$t('notify.notify'),
          text: this.$t('notify.create_success')
        })
        this.$refs.create.hide()
        this.btn_submit = false
        
      }).catch(errors => {
        if (errors.status === 422) {
          this.errors = errors.data.error
        }
        this.btn_submit = false
        
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/group-alias/create/create.js